module.exports = __webpack_public_path__ + "static/img/6.b7b4e66.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/zh/6.png
// module id = mvx0
// module chunks = 0